export interface CountryDialOption {
  iso: string;
  name: string;
  dialCode: string;
}

/** Quelques libellés plus naturels que ceux rendus par Intl.DisplayNames. */
const NAME_OVERRIDES: Record<string, string> = {
  CD: 'RD Congo',
};

/** Option affichée avant le chargement complet, et en cas d'échec de celui-ci. */
export const DEFAULT_COUNTRY_OPTIONS: CountryDialOption[] = [
  { iso: 'CD', name: 'RD Congo', dialCode: '+243' },
];

let cached: CountryDialOption[] | undefined;

/**
 * Charge, à la demande, la liste complète des pays et de leurs indicatifs
 * téléphoniques (via libphonenumber-js) avec un nom en français (via
 * Intl.DisplayNames). Chargé dynamiquement pour ne pas alourdir le bundle
 * initial du site public avec les métadonnées de tous les pays.
 */
export async function loadCountryDialOptions(): Promise<CountryDialOption[]> {
  if (cached) return cached;
  const { getCountries, getCountryCallingCode } = await import('libphonenumber-js/min');
  const displayNames =
    typeof Intl !== 'undefined' && 'DisplayNames' in Intl
      ? new Intl.DisplayNames(['fr'], { type: 'region' })
      : undefined;
  const options = getCountries()
    .map((iso) => ({
      iso,
      name: NAME_OVERRIDES[iso] || displayNames?.of(iso) || iso,
      dialCode: `+${getCountryCallingCode(iso)}`,
    }))
    .sort((a, b) => a.name.localeCompare(b.name, 'fr'));
  cached = options;
  return options;
}
